module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"tables":"Tables","roundOver":"Round Over","startRound":"Start Round","nextRound":"Next Round"},"message":{"noTable":"No tables"}},"ja":{"label":{"tables":"試合卓一覧","roundOver":"試合終了","startRound":"試合開始","nextRound":"試合開始"},"message":{"noTable":"卓はありません"}}}')
  delete Component.options._Ctor
}
